const unfocusTag = ({ state, props, path }) => {
  const focusedTag = state.get(`selectr.${props.namespace}.focusedTag`)
  if (focusedTag !== null) {
    state.set(
      `selectr.${props.namespace}.selected.${focusedTag}.focused`,
      false
    )
  }
}

unfocusTag.displayName = 'unfocusTag'
export default unfocusTag
